import { render } from "./Customerservice.vue?vue&type=template&id=38b73c38&scoped=true"
import script from "./Customerservice.vue?vue&type=script&lang=js"
export * from "./Customerservice.vue?vue&type=script&lang=js"

import "./Customerservice.vue?vue&type=style&index=0&id=38b73c38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b73c38"]])

export default __exports__